import React from 'react';
import { ArrowRight, Mail, Phone, MessageCircle } from 'lucide-react';
import { ctaContent } from '../data/mock';

const CTASection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main CTA */}
        <div className="relative overflow-hidden rounded-3xl">
          {/* Background gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600" />
          
          {/* Pattern overlay */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC40Ij48cGF0aCBkPSJNMzYgMzRjMC0yLjIgMS44LTQgNC00czQgMS44IDQgNC0xLjggNC00IDQtNC0xLjgtNC00em0wLTMwYzAtMi4yIDEuOC00IDQtNHM0IDEuOCA0IDQtMS44IDQtNCA0LTQtMS44LTQtNHptLTMwIDBjMC0yLjIgMS44LTQgNC00czQgMS44IDQgNC0xLjggNC00IDQtNC0xLjgtNC00em0wIDMwYzAtMi4yIDEuOC00IDQtNHM0IDEuOCA0IDQtMS44IDQtNCA0LTQtMS44LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')]" />
          </div>

          {/* Content */}
          <div className="relative z-10 px-8 py-16 md:px-16 md:py-24">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
                {ctaContent.title}
              </h2>
              <p className="text-lg text-white/80 mb-10">
                {ctaContent.description}
              </p>
              
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <button className="w-full sm:w-auto px-8 py-4 bg-white text-slate-900 font-semibold rounded-full hover:bg-slate-100 transition-colors flex items-center justify-center gap-2 group">
                  {ctaContent.primaryCta}
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
                <button className="w-full sm:w-auto px-8 py-4 bg-white/10 text-white font-semibold rounded-full border border-white/30 hover:bg-white/20 transition-colors">
                  {ctaContent.secondaryCta}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Contact options */}
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          <div className="p-6 bg-slate-50 rounded-2xl hover:bg-slate-100 transition-colors group cursor-pointer">
            <div className="w-12 h-12 rounded-xl bg-indigo-100 flex items-center justify-center mb-4 group-hover:bg-indigo-200 transition-colors">
              <Mail className="w-6 h-6 text-indigo-600" />
            </div>
            <h3 className="font-semibold text-slate-900 mb-2">Email Us</h3>
            <p className="text-sm text-slate-600 mb-3">Send us a message anytime</p>
            <span className="text-indigo-600 font-medium">contact@3strandcord.org</span>
          </div>
          
          <div className="p-6 bg-slate-50 rounded-2xl hover:bg-slate-100 transition-colors group cursor-pointer">
            <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center mb-4 group-hover:bg-emerald-200 transition-colors">
              <Phone className="w-6 h-6 text-emerald-600" />
            </div>
            <h3 className="font-semibold text-slate-900 mb-2">Prayer Line</h3>
            <p className="text-sm text-slate-600 mb-3">24/7 prayer support available</p>
            <span className="text-emerald-600 font-medium">1-800-PRAY-NOW</span>
          </div>
          
          <div className="p-6 bg-slate-50 rounded-2xl hover:bg-slate-100 transition-colors group cursor-pointer">
            <div className="w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center mb-4 group-hover:bg-purple-200 transition-colors">
              <MessageCircle className="w-6 h-6 text-purple-600" />
            </div>
            <h3 className="font-semibold text-slate-900 mb-2">Live Chat</h3>
            <p className="text-sm text-slate-600 mb-3">Chat with our team</p>
            <span className="text-purple-600 font-medium">Start a conversation</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
